import fetch from "lib/fetch";
import type { BookingInterface } from "types/booking";
import type { UserInterface } from "types/user";
import type { Payment } from "types/bookService";

type BookingResponse = { data: BookingInterface };
type UserResponse = { data: UserInterface };
type PaymentResponse = { data: Payment };
type UnknownResponse = { data: unknown };

export const setBookServiceClientRequest = (id: string) =>
    fetch.put<BookingResponse>(`book_service/${id}/set_client`);

export const updateBookServiceBookSlotsRequest = (id: string, data?: unknown) =>
    fetch.put<BookingResponse>(`book_service/${id}/resume`, data);

export const validateBookServiceRegisterAccountRequest = (data?: HashMap<unknown>) =>
    fetch.post<UserResponse>("book_service/validate_register_account", data);

export const createBookServicePaymentRequest = (id: string, data?: HashMap<unknown>) =>
    fetch.post<PaymentResponse>(`book_service/${id}/payment`, data);

export const updateBookServicePaymentRequest = (id: string, data?: HashMap<unknown>) =>
    fetch.post<PaymentResponse>(`book_service/${id}/update_payment`, data);

export const captureBookServicePaymentRequest = (data: HashMap<unknown>) =>
    fetch.post<UnknownResponse>("book_service/capture_payment", data);

export const confirmBookServicePaymentRequest = (data: HashMap<unknown>) =>
    fetch.post<UnknownResponse>("book_service/confirm_payment", data);
